export default __webpack_public_path__ + "static/media/bracket.0a0f9458.png";